<template>
  <section class="section sidearm-mm-run bg-white" data-anchor="tournament-run">
    <div class="sidearm-mm-run__inner">
      <div class="sidearm-mm-run__intro">
        <h2 class="type-heading-bracket-plain text-center">
          {{ this.$root.year }} Tournament Run &amp; History
        </h2>
        <p class="type-paragraph-large text-center">
          Expand to view full tournament coverage and details.
        </p>
      </div>
      <div
        class="sidearm-mm-run__games pb-4"
        v-if="$root.games_with_data && $root.games_with_data.length"
      >
        <run-game-current
          v-if="$root.upcoming_game !== null"
          :round="$root.upcoming_game"
        />

        <run-game-previous
          v-for="round in $root.past_games"
          :key="round.game.id"
          :round="round"
        />
      </div>
    </div>
  </section>
</template>

<script>
import RunGameCurrent from "@/components/RunGameCurrent";
import RunGamePrevious from "@/components/RunGamePrevious";

export default {
  name: "SectionTournamentRun",
  components: {
    RunGameCurrent,
    RunGamePrevious
  },
  data: () => ({}),

  computed: {
    section() {
      if (!this.$root.data) {
        return null;
      }
      return this.$root.data.tournament_section;
    }
  },

  methods: {},

  created() {}
};
</script>
<style lang="scss" scoped>
.sidearm-mm-run {
  &__inner {
    padding-top: $header-height;
    padding-left: 12px;
    padding-right: 12px;
  }
}
</style>
